import { createUseStyles } from 'react-jss';

import { colors } from 'resources/styles/colors';

const useStyles = createUseStyles(() => ({
  appleLoginButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    position: 'relative',

    '&.primaryDisplay': {
      color: colors.white,
      backgroundColor: colors.black,

      '&:focus': {
        backgroundColor: 'rgba(0, 0, 0, .75)',
      },

      '&:not([disabled]):hover': {
        backgroundColor: 'rgba(0, 0, 0, .75)',
      },
    },

    '& .prefixIcon': {
      left: '6px',
      top: '50%',
      position: 'absolute',
      display: 'block',
      transform: 'translateY(-50%)',

      '& svg': {
        width: '18px',
        height: '18px',

        '@media screen and (min-width: 1441px)': {
          width: '20px',
          height: '20px',
        },
      },

      '@media screen and (min-width: 1441px)': {
        left: '8px',
      },
    },
  },
}));

export default useStyles;
